import { connect } from 'react-redux';
import Lyp from './Lyp';

const mapStateToProps = ({ content: { lyp }}) => ({
  title: lyp.title,
  imageUrl: lyp.imageUrl,
  callToActionText: lyp.btnText,
  callToActionUrl: lyp.lypUrl
});

export default connect(mapStateToProps)(Lyp);
